import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import UserRow from "src/components/Layout/UserRow";
import localforage from "localforage";
import { useNavigate } from "react-router";
import { connect } from "react-redux";
import { insert } from "src/pages/admin/settingV3/helpers";
import "src/App.css";
import { version } from "src/configs/globalVariable";

const Index = ({ isAuthenticated, heightHeader }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    checkParamsUrl();
    fetchData();
  }, []);

  const checkParamsUrl = async () => {
    if (!isAuthenticated) {
      navigate(`/${version}/user/`);
      window.location.reload();
      return;
    }
  };
  const fetchData = async () => {
    const resTempData = await localforage.getItem("tempData");
    const num = heightHeader?.split("rem")[0];
    tempDataContent.sectProps.pt = num * 3 + "rem";
    tempDataContent.sectProps.pb = num * 2 + "rem";
    const tempData = insert(resTempData, 1, tempDataContent);
    setData(tempData);
  };

  const renderRow = (row) => {
    return <UserRow key={row.id} data={row} />;
  };

  return (
    <Grid
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F6F8FD",
      }}
    >
      {data
        .filter((v) => v.visibility)
        .map((row) => {
          return <React.Fragment key={row.id}>{renderRow(row)}</React.Fragment>;
        })}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  heightHeader: state.preview.heightHeader,
});

export default connect(mapStateToProps)(Index);

const tempDataContent = {
  id: "nbajwLmRk",
  type: "row",
  props: {
    maxWidth: "75%",
  },
  children: [
    {
      id: "31ZVfDnAV",
      type: "column",
      props: {},
      children: [
        {
          id: "Wa2MSTlSv",
          type: "element",
          variant: "element41", // Profile => shortcut : component in list elements library.js
        },
      ],
      colWidth: 12,
    },
  ],
  sectProps: {},
  visibility: true,
};
